export const DATE_TEMPLATE = 'YYYY-MM-DD';

export const toDateInput = (millis) => {
  if (!millis) return '';
  const date = new Date(millis);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const toUnixMillis = (value, endOfDay = false) => {
  if (!value) return undefined;
  const time = endOfDay ? 'T23:59:59.999' : 'T00:00:00';
  return new Date(`${value}${time}`).getTime();
};

const clampPart = (part, min, max) => {
  const n = Math.min(Math.max(Number(part), min), max);
  return String(n).padStart(2, '0');
};

export const maskDate = (raw) => {
  const digits = raw.replace(/\D/g, '').slice(0, 8);
  const year = digits.slice(0, 4);
  let month = digits.slice(4, 6);
  let day = digits.slice(6, 8);

  if (month.length === 2) month = clampPart(month, 1, 12);
  if (day.length === 2) day = clampPart(day, 1, 31);

  return [year, month, day].filter((part, i) => i === 0 || part).join('-');
};

const isComplete = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value);

export const isInvalidDate = (value, min, max) => {
  if (!isComplete(value)) return false;
  const [y, m, d] = value.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  const isRealDate =
    dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d;
  if (!isRealDate) return true;
  if (min && value < min) return true;
  if (max && value > max) return true;
  return false;
};
